import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ContentSection from './components/ContentSection';
import ArticleSection from './components/ArticleSection';
import FAQ from './components/FAQ';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.space';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'VigorBuy Spread',
  url: siteUrl,
  description: 'Complete Kakobuy Spreadsheet guide including templates, reviews, comparisons, security tips and productivity solutions for smarter data management. Expert resources for ecommerce sellers and business owners.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'VigorBuy Spread',
  url: siteUrl,
  description: 'Educational resource platform focused on helping users understand, compare and optimize spreadsheet solutions for business data management.',
  sameAs: ['https://kaspreadsheet.com'],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is VigorBuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'VigorBuy Spreadsheet is a comprehensive data management resource platform that provides structured templates, guides, and productivity strategies for businesses and professionals. It helps users organize data, automate workflows, and generate actionable insights — whether you are managing ecommerce inventory, financial records, marketing analytics, or project timelines.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does VigorBuy Spreadsheet work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'VigorBuy Spreadsheet works by offering ready-to-use spreadsheet frameworks tailored to specific business functions. Users can select a template that matches their needs, customize it with their own data, and immediately start benefiting from organized, analyzable information.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is VigorBuy Spreadsheet secure?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely. Security is a cornerstone of the VigorBuy Spreadsheet approach. All templates and guides incorporate best practices for data privacy, access control, and secure sharing. We provide clear recommendations on backup strategies, encryption methods, and safe collaboration practices.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is VigorBuy Spreadsheet better than Excel?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'VigorBuy Spreadsheet and Excel serve complementary purposes. While Excel is a general-purpose spreadsheet tool, VigorBuy Spreadsheet provides specialized, business-focused templates and workflows that accelerate specific tasks like ecommerce management, inventory tracking, and sales analytics.',
      },
    },
    {
      '@type': 'Question',
      name: 'Who should use VigorBuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'VigorBuy Spreadsheet is designed for ecommerce sellers, small business owners, operations managers, data analysts, marketing professionals, and anyone who regularly works with structured data.',
      },
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <CategoryGrid />
      <ContentSection />
      <ArticleSection />
      <FAQ />
      <CTABanner />
      <Footer />
    </main>
  );
}